import React from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { colors } from '../../styles/colors';
import './BaseModal.css';

Modal.setAppElement('#root');

const BaseModal = ({ 
  isOpen, 
  onClose, 
  title, 
  children, 
  footer,
  maxWidth = '600px',
  width = '90%'
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="modal-content"
      overlayClassName="modal-overlay"
      style={{
        overlay: {
          backgroundColor: colors.overlay.default,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '1rem',
          zIndex: 1040,
          overflow: 'auto'
        },
        content: {
          position: 'relative',
          background: colors.background.modal,
          border: `1px solid ${colors.border.default}`,
          borderRadius: '0.5rem',
          width: width,
          maxWidth: maxWidth,
          maxHeight: '90vh',
          margin: 'auto',
          padding: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }
      }}
    >
      <div className="modal-header">
        <h5 className="modal-title">{title}</h5>
        <button
          type="button"
          className="btn-close btn-close-white"
          onClick={onClose}
          aria-label="Close"
        />
      </div>
      
      <div className="modal-body">
        {children}
      </div>

      <div className="modal-footer">
        {footer}
      </div>
    </Modal>
  );
};

BaseModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  footer: PropTypes.node.isRequired,
  maxWidth: PropTypes.string,
  width: PropTypes.string
};

export default BaseModal;
